import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import styles from './Breadcrumb.module.css';

const breadcrumbMap = {
  dashboard: 'Dashboard',
  profile: 'My Profile',
  loans: 'Loans',
  savings: 'Savings',
};

export default function Breadcrumb() {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;

  const getSegmentLabel = (segment, path) => {
    if (segment === 'ledger') {
      return path.startsWith('/savings/') ? 'Savings Ledger' : 'Loan Ledger';
    }

    if (segment === 'overview') {
      return path.startsWith('/savings/') ? 'Savings Overview' : 'Loan Overview';
    }
    if (path.startsWith('/savings/member-ledger')) {
  return "Member's Savings  Ledger";
  }
    if (path.startsWith('/loans/member-ledger' )) {
  return "Member's Loan  Ledger";
  }
    if (path.startsWith('/savings/member-withdrawal')) {
  return 'Member Withdrawl';
  }
    if (path.startsWith('/loans/apply')) {
  return 'Loan Application';
  }

    // if (segment === 'loan') {
    //   return path.startsWith('/loans/member-ledger') ? '' : 'Member Savings';
    // }

    return breadcrumbMap[segment] || segment.charAt(0).toUpperCase() + segment.slice(1);
  };

  // Generate breadcrumb items from path
  const generateBreadcrumbs = () => {
    const segments = pathname.split('/').filter(Boolean);
    const breadcrumbs = [{ label: 'Dashboard', path: '/dashboard' }];

    let currentPath = '';
    segments.forEach((segment) => {
      currentPath += `/${segment}`;
      const label = getSegmentLabel(segment, currentPath);
      breadcrumbs.push({ label, path: currentPath });
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <nav className={styles.breadcrumb} aria-label="Breadcrumb">
      {breadcrumbs.map((crumb, index) => (
        <React.Fragment key={crumb.path}>
          {index > 0 && <ChevronRight size={16} className={styles.separator} />}
          {index === breadcrumbs.length - 1 ? (
            <span className={styles.current}>{crumb.label}</span>
          ) : (
            <button
              type="button"
              className={styles.link}
              onClick={() => handleNavigate(crumb.path)}
            >
              {crumb.label}
            </button>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}
